import React from 'react';
import { StarIcon } from 'lucide-react';
interface TestimonialCardProps {
  quote: string;
  author: string;
  location: string;
  image: string;
}
export function TestimonialCard({
  quote,
  author,
  location,
  image
}: TestimonialCardProps) {
  return <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300" data-id="element-308">
      <div className="flex gap-1 mb-4" data-id="element-309">
        {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-gold-400 text-gold-400" data-id="element-310" />)}
      </div>

      <p className="text-gray-700 text-lg mb-6 italic leading-relaxed" data-id="element-311">
        "{quote}"
      </p>

      <div className="flex items-center gap-4" data-id="element-312">
        <img src={image} alt={author} className="w-12 h-12 rounded-full object-cover" data-id="element-313" />
        <div data-id="element-314">
          <p className="font-bold text-navy-900" data-id="element-315">{author}</p>
          <p className="text-sm text-gray-500" data-id="element-316">{location}</p>
        </div>
      </div>
    </div>;
}